<div class="auth-layout" [class.auth-layout--mailing]="outlet.isActivated && outlet.activatedRouteData['screenKey'] === 'MailingUnsubscribe'">
  <div class="auth-layout__backdrop" aria-hidden="true"></div>

  <div class="auth-layout__viewport">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</div>
